/* eslint-disable */
/*LIST PRODUCT created to handle the WLC Challenge.
root.Children will be an array of lists.  Each list will represent a day.
It has a AppSync integration so it knows what list to show on a given day.
It could be augmented to create any product that is simply a list of Content Items*/
import React, { Component, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';
import { faHome } from '@fortawesome/pro-regular-svg-icons/faHome';
import { Switch, Route } from 'react-router-dom';
import { actions } from 'modules/modal';
import { actions as userActions } from 'modules/user';
import RecipePage from '../../products/WLC/pages/Recipe';
import { withPhaseProvider } from 'lib/scheduleContext';
//import useAppSync from '../../../../lib/useAppSync';
import { product } from './data.js';
import { Alert, Button, Container, Row, Col, Carousel, Modal } from 'reactstrap';
import VideoResource from '../../components/VideoResource';
import { ForumWrapper } from 'components/ForumWrapper';
import RecipesPage from './pages/RecipesPage';
import CarouselV3 from '../../components/CarouselV3';
import InternalAd from './components/InternalAd';
import { AmityUiKitProvider, AmityUiKitSocial, AmityPostDetailPage } from '@frn/amityco-ui-kit-open-source';
import SocialPlusPostPage from './components/SocialPlusPostPage';
import SocialPlusApp from 'components/SocialPlusApp';
const HomePage = ({
  recipeCards,
  handleNav,
  highlightedComment,
  lists,
  productSlug,
  revokeDiscourseAPIKey,
  refreshToken,
  scrollToContent,
  slug,
  title,
  user,
  videoResourceIndex = 0,
  postId,
  autoJoinCommunityId
}) => {
  const [showForumModal, setShowForumModal] = useState(false);

  const openForumModal = () => setShowForumModal(true);
  const closeForumModal = () => setShowForumModal(false);

  const currentList = lists[0];
  const videoCards = currentList.Children.filter(item => item.type === 'videoResource');
  const currentVideoResource = videoCards[videoResourceIndex];

  return (
    <Container>
      {/* 🚀 Forum Modal */}
      <Modal
        isOpen={showForumModal}
        toggle={closeForumModal}
        size="xl"
        style={{ maxWidth: '95vw', width: '95%' }}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title">Community Forum</h5>
          <button type="button" className="close" onClick={closeForumModal}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div className="modal-body">
          <SocialPlusPostPage
            autoJoinCommunityId={autoJoinCommunityId}
            styleObject={{
              position: 'absolute',
              left: 0,
              top: '0px',
              width: '100%',
              height: '75dvh',
              overflow: 'visible'
            }}
          />
        </div>

        <div className="modal-footer">
          <Button color="secondary" onClick={closeForumModal}>
            Close
          </Button>
        </div>
      </Modal>

      {/* 🚀 Button to open Forum Modal */}
      {/* <div className="text-center my-4">
        <Button color="primary" onClick={openForumModal}>
          Open Forum
        </Button>
      </div> */}

      {/* Existing homepage layout */}
      <Row>
        <Col>
          <VideoResource {...currentVideoResource} showComments={false} autoPlay />
          {/*<RecipesList Children={currentRecipes} disableViewAll />*/}
        </Col>
      </Row>

      <CarouselV3
        cards={videoCards}
        darkText
        linkTo={`/products/${productSlug}/`}
        handleNav={handleNav}
        title={'Live Challenge Videos'}
        variant="light"
      />

      <CarouselV3
        cards={recipeCards}
        darkText
        linkTo={`/products/${productSlug}/recipes`}
        handleNav={handleNav}
        title={'Live Challenge Recipes'}
        variant="light"
      />

      {user && user.products && user.products.find(item => item.slug === 'wlc') ? null : (
        <InternalAd img={'https://cdn.foodrevolution.org/members/assets/img/iStock-1315353793.jpg'} />
      )}
      <Alert color="warning">Looking for today's episode? Scroll up to view the latest video.</Alert>
      <div>
        <SocialPlusApp
          usePostDetailPage={true}
          useForum={false}
          autoJoinCommunityId={autoJoinCommunityId}
          postId={postId}
          useProvider={false}
          user={user}
          styleObject={{
            position: 'relative',
            height: '75dvh'
          }}
        />
        {/* <SocialPlusPostPage
          styleObject={{
            position: 'relative'
          }}
          id={'681255f62575900947cd09e9'}
          //  id={'6812543d1d47ebad18f11791'}
        /> */}
      </div>
      <style>{`button[data-testid$='post_detail_page/post_content/comment_button'], button[data-testid$='post_detail_page/post_content/reaction_button']{display: none;}`}</style>
    </Container>
  );
};
/*const AppSyncHandler = ({scheduleUrl, subscribeKey, channel}) => {
  useAppSync();
  return <></>;
};*/

//THE HIGH LEVEL PRODUCT COMPONENTS BASICALLY BECOME ROUTE PRODUCERS.  ALL THE ROUTES ARE RENDERED HERE
class ListProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      product: props, //importProductJson,
      today: Date.now(),
      disableRouter: false,
      currentContent: null,
      navItems: [{ name: 'Home', typeOfComponent: null, slug: null, icon: faHome }], //used to show what nav items are present in top};
      carouselWidth: 1020
    };

    this.handleNav = this.handleNav.bind(this);
    this.setPages = this.setPages.bind(this);
    this.scrollToContent = this.scrollToContent.bind(this);
    this.getAuthToken = this.getAuthToken.bind(this);
    const thisPath = location.pathname.split('/');
    this.thisProductInPath = thisPath[2];
    this.highlightedComment = React.createRef();
  }

  scrollToContent() {
    setTimeout(() => {
      const offSet =
        this.highlightedComment.current &&
        this.highlightedComment.current.scrollIntoView(false, { behavior: 'smooth' });
      window.scrollTo({
        top: offSet,
        behavior: 'smooth'
      });
    }, 1000);
  }

  componentDidMount() {
    console.log('this.props.user ', this.props.user);
    window.scrollTo(0, 0);
    window.onpopstate = this.history;
    this.setPages();
  }

  setPages() {
    const { product } = this.state;
    //get the lists for each day.  Pre challenge = index 0, first day = index 1
    //list = [videoResource, recipe, recipe]
    const lists = product.Children.filter(item => item.type === 'list');
    const videoResources = lists[0].Children.filter(item => item.type === 'videoResource');
    //get all recipes to create routes
    let allRecipes = lists.map(list => list.Children.filter(item => item.type === 'recipe'));
    allRecipes = _.flattenDeep(allRecipes);
    let recipeList = lists.find(list => list.Children.find(item => item.type === 'recipe'));
    this.setState({
      allRecipes,
      recipeList,
      lists,
      videoResources
    });
    return;
  }

  handleNav = (name, component, slug, slugTwo) => {
    //for navigating to a single recipe
    if (slug && slugTwo) {
      const path = `/products/${this.thisProductInPath}/${slug}/${slugTwo}`;
      this.props.history.push(path);
    }
    //navigating to a day or recipes page
    if (slug && !slugTwo) {
      this.props.history.push(`/products/${this.thisProductInPath}/${slug}`);
    }
    //navigate home
    if (!slug && !slugTwo) {
      const path = `/products/${this.thisProductInPath}`;
      this.props.history.push(path);
    }
    window.scrollTo(0, 0);
  };
  getAuthToken = async () => {
    const token = await this.props.retrieveSocialPlusToken(this.thisProductInPath);
    return token;
  };

  render() {
    const {
      allRecipes,
      carouselWidth,
      lists,
      navItems,
      product: { slug },
      recipeList,
      today,
      videoResources
    } = this.state;
    const { user } = this.props;
    const { socialPlusApiKey, autoJoinCommunityId, postId } = this.props.data;
    console.log('user', user);
    const { phase = 'before', day = 0 } = this.props.phaseState.phases?.broadcast ?? {};

    //set up SOCIAL PLUS values
    const { userId, firstName, lastName } = user;
    const userIdString = userId.toString();
    const displayName = `${firstName} ${lastName.charAt(0).toUpperCase()}`;
    console.log('userIdString', userIdString);
    console.log('displayName', displayName);
    console.log('socialPlusApiKey', socialPlusApiKey, 'autoJoinCommunityId', autoJoinCommunityId, 'postId', postId);
    return socialPlusApiKey ? (
      <AmityUiKitProvider
        key={userId}
        apiKey={socialPlusApiKey}
        userId={userIdString}
        displayName={displayName}
        apiRegion={'US'}
        getAuthToken={this.getAuthToken}
      >
        <div>
          <Switch>
            {/* Individual Recipes  */}
            {allRecipes && allRecipes.length
              ? allRecipes.map(recipe => {
                  return (
                    <Route
                      key={recipe.slug}
                      exact
                      path={`/products/${this.thisProductInPath}/${recipe.slug}`}
                      render={routeProps => (
                        <RecipePage
                          {...routeProps}
                          {...recipe}
                          navItems={navItems}
                          handleNav={this.handleNav}
                          recipes={recipeList.Children}
                          product={this.state.product}
                          currentContent={recipe}
                          singleRecipeInUrl={recipe.slug}
                          productPath={this.thisProductInPath}
                          hideComments={true}
                          includeBackNav={true}
                        />
                      )}
                    />
                  );
                })
              : null}
            {/* all recipes */}
            {recipeList && recipeList.Children && recipeList.Children.length ? (
              <Route
                key={'live-challenge-recipes'}
                exact
                path={`/products/${this.thisProductInPath}/recipes`}
                render={routeProps => (
                  <RecipesPage
                    {...routeProps}
                    navItems={navItems}
                    handleNav={this.handleNav}
                    recipes={recipeList.Children}
                    product={this.state.product}
                    productPath={this.thisProductInPath}
                  />
                )}
              />
            ) : null}
            {videoResources && videoResources.length
              ? videoResources.map((videoResource, idx) => {
                  console.log(`/products/${this.thisProductInPath}/${videoResource.slug}`);
                  return (
                    <Route
                      key={`live-challenge-${this.thisProductInPath}-${videoResource.slug}`}
                      exact
                      path={`/products/${this.thisProductInPath}/${videoResource.slug}`}
                      render={routeProps => (
                        <HomePage
                          user={this.props.user}
                          product={product}
                          lists={lists}
                          title={'Live Challenge'}
                          slug={slug}
                          handleNav={this.handleNav}
                          today={today}
                          carouselWidth={carouselWidth}
                          productSlug={this.thisProductInPath}
                          refreshToken={this.props.refreshToken}
                          highlightedComment={this.highlightedComment}
                          scrollToContent={this.scrollToContent}
                          revokeDiscourseAPIKey={this.props.revokeDiscourseAPIKey}
                          recipeCards={recipeList.Children}
                          videoCards={lists[0]}
                          videoResourceIndex={idx}
                          autoJoinCommunityId={autoJoinCommunityId}
                          postId={postId}
                        />
                      )}
                    />
                  );
                })
              : null}
            {lists && lists.length ? (
              <Route
                key={`live-challenge-${this.thisProductInPath}`}
                exact
                path={`/products/${this.thisProductInPath}`}
                render={routeProps => (
                  <HomePage
                    user={this.props.user}
                    product={product}
                    lists={lists}
                    title={'Live Challenge'}
                    slug={slug}
                    handleNav={this.handleNav}
                    today={today}
                    carouselWidth={carouselWidth}
                    productSlug={this.thisProductInPath}
                    refreshToken={this.props.refreshToken}
                    highlightedComment={this.highlightedComment}
                    scrollToContent={this.scrollToContent}
                    revokeDiscourseAPIKey={this.props.revokeDiscourseAPIKey}
                    recipeCards={recipeList.Children}
                    videoCards={lists[0]}
                    autoJoinCommunityId={autoJoinCommunityId}
                    postId={postId}
                  />
                )}
              />
            ) : (
              ''
            )}
            {lists && lists.length ? (
              <Route
                key={`live-challenge-${this.thisProductInPath}/forum`}
                exact
                path={`/products/${this.thisProductInPath}/forum`}
                render={routeProps => (user ? <SocialPlusForum /> : null)}
              />
            ) : (
              ''
            )}
          </Switch>
        </div>
      </AmityUiKitProvider>
    ) : (
      <div>Loading...</div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user
});

const mapDispatchToProps = dispatch => ({
  get: contendId => dispatch(actions.getUserData(contendId)),
  post: (contentId, data) => dispatch(actions.postUserData(contentId, data)),
  refreshToken: userActions.refreshToken,
  revokeDiscourseAPIKey: userActions.revokeDiscourseAPIKey,
  retrieveSocialPlusToken: productSlug => dispatch(userActions.retrieveSocialPlusToken(productSlug))
});

const ConnectedListProduct = connect(mapStateToProps, mapDispatchToProps)(ListProduct);
const EnhancedListProduct = withPhaseProvider(withRouter(ConnectedListProduct));

export default EnhancedListProduct;
